import { cva } from 'class-variance-authority';
const radioGroupItemSizeMap = {
    default: 'size-[length:var(--choice-size)]',
    md: 'size-[length:var(--choice-size-md)]',
    sm: 'size-[length:var(--choice-size-sm)]',
    lg: 'size-[length:var(--choice-size-lg)]',
};
const radioDotSizeMap = {
    default: 'size-2',
    md: 'size-2',
    sm: 'size-1.5',
    lg: 'size-2.5',
};
/** CVA variants 맵 — lab·문서용 키 추출의 SSOT. */
export const radioGroupItemCva = {
    variants: {
        size: radioGroupItemSizeMap,
    },
    defaultVariants: {
        size: 'default',
    },
};
export const radioGroupItemVariants = cva('border-input text-primary focus-visible:border-ring focus-visible:ring-ring/50 aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive dark:bg-input/30 aspect-square shrink-0 rounded-full border shadow-xs transition-[color,box-shadow] outline-none focus-visible:ring-[3px] disabled:cursor-not-allowed disabled:opacity-50', radioGroupItemCva);
/** CVA에 정의된 size 키 (삽입 순서 유지). */
export const radioGroupItemSizeKeys = Object.keys(radioGroupItemCva.variants.size);
/** 선택 표시 dot 크기 — Item size와 짝. */
export function radioDotClass(size) {
    const key = size && size in radioDotSizeMap ? size : 'default';
    return radioDotSizeMap[key];
}
//# sourceMappingURL=radio-group-item.cva.js.map